<template>
    <div class="tool-panel-actions p-md display-flex flex-column justify-between">
        <div v-if="params.showToolHeader !== false" class="tool-header">
            <div class="tool-panel-header display-flex items-end">
                <p class="bold small">{{ selectedRows.length }} Companies Selected</p>
                <p class="extra-small ml-sm">(Limit 25)</p>
            </div>
            <p
                class="small link mt-sm"
                :class="{ disabled: selectedRows.length === 0 }"
                @click="clearSelections()"
            >
                Clear Selections
            </p>
        </div>
        <div class="actions mt-md display-flex flex-column justify-between h-100">
            <div class="upper-actions">
                <div
                    v-if="params.showRemoveFromWatchlistAction"
                    class="action display-flex align-items-center mt-sm"
                    :class="{ disabled: selectedRows.length === 0 }"
                    @click="onActionSelection('remove')"
                >
                    <font-awesome-icon class="text-primary icon mr-sm" icon="fas fa-xmark" />
                    <p class="small text-primary cursor">Remove to Watchlist</p>
                </div>
                <div
                    v-if="params.showTechAreaBreakdownAction"
                    class="action display-flex align-items-center mt-sm"
                    :class="{ disabled: selectedRows.length === 0 }"
                    @click="onActionSelection('techAreaBreakdown')"
                >
                    <font-awesome-icon class="text-primary icon mr-sm" icon="fas fa-list-tree" />
                    <p class="small text-primary cursor">Tech Area Breakdown</p>
                </div>
            </div>
            <div class="lower-actions w-100 display-flex pt-sm">
                <div
                    v-if="params.tableExportAction"
                    class="action display-flex align-items-center"
                    @click="onActionSelection('exportTable')"
                >
                    <font-awesome-icon class="text-primary icon mr-sm" icon="fas fa-download" />
                    <p class="small text-primary cursor">Export Table</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, onMounted, onUnmounted, ref } from 'vue'

const eventBus = inject('eventBus')
const emit = defineEmits(['setup-arena'])
const props = defineProps({
    params: Object,
})
const selectedRows = ref([])

onMounted(() => {
    eventBus.on('row-selected', () => {
        selectedRows.value = props.params.api.getSelectedRows()
    })
})

onUnmounted(() => {
    eventBus.off('row-selected')
})

const onActionSelection = (actionType) => {
    if (actionType === 'remove') {
        props.params.removeFromWatchlistAction(props.params)
    } else if (actionType === 'techAreaBreakdown') {
        props.params.techAreaBreakdownAction(props.params)
    } else if (actionType === 'exportTable') {
        props.params.tableExportAction(props.params)
    }
}
const clearSelections = () => {
    props.params.clearSelections(props.params)
}
</script>

<style lang="scss" scoped>
@use '@moatmetrics/armory/src/sass/token-utils' as tokens;

.action {
    p {
        &:hover {
            text-decoration: underline;
        }
    }
}

.lower-actions {
    border-top: var(--border-width-thin) solid var(--color-primary-darker);
}

.disabled {
    opacity: 0.5;
    pointer-events: none;
}

.cursor {
    cursor: pointer;
}
</style>
